module.exports = __webpack_public_path__ + "media/assets/images/btn_analysis_s-babce620c073444c38d96e5f21eaf81d.png";